import React from "react";

import Tab from "@mui/material/Tab";
import MuiTabs, { TabsProps } from "@mui/material/Tabs";
import styled from "styled-components";

import { color } from "../../tokens";
import { BetaBadge } from "../BetaBadge/BetaBadge";
import { Tab as TabType } from "../types";
import { hexToRgba } from "../utils";
import { useTabs } from "./useTabs";

interface Props extends Omit<TabsProps, "children" | "onChange"> {
  tabs: TabType[];
  redirectToFirst?: boolean;
  variant?: "scrollable" | "fullWidth" | "standard";
  onChange?: (index: number) => void;
}

export const Tabs: React.FC<Props> = (props) => {
  const { tabs, redirectToFirst, variant = "standard", ...rest } = props;
  const { value, onChange } = useTabs({
    tabs,
    redirectToFirst,
    onChange: props.onChange,
  });

  return (
    <MuiTabs
      {...rest}
      value={value === -1 ? false : value}
      onChange={onChange}
      variant={variant}
      scrollButtons="auto"
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.url}
          label={tab.label}
          sx={{
            textTransform: "none",
            paddingX: 2,
            minHeight: "3rem",
            minWidth: 0,
          }}
          icon={
            tab.badgeValue ? (
              typeof tab.badgeValue === "number" ? (
                <Badge>{tab.badgeValue}</Badge>
              ) : (
                <StatusBadgeWrapper>
                  <BetaBadge />
                </StatusBadgeWrapper>
              )
            ) : undefined
          }
          iconPosition="end"
        />
      ))}
    </MuiTabs>
  );
};

const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  width: 1rem;
  height: 1rem;
  font-size: 0.7rem;
  color: ${color.basic.white};
  background-color: ${color.red[400]};
  border-radius: 50%;
  box-shadow: 0 0 0.25rem ${hexToRgba(color.red[400], 0.3)};
`;

const StatusBadgeWrapper = styled.div`
  margin-left: 0.25rem;
`;
